import { useIntl } from "react-intl";
import type { ApiOperations } from "~enums/apiOperations";
import type { ApiOperationItems } from "~enums/apiOperationItems.ts";
import { useNotification } from "~hooks/useNotification.ts";

export const useApiOperationNotifications = (item: ApiOperationItems) => {
  const { formatMessage } = useIntl();
  const notification = useNotification();

  const formatOperationMessage = (messageId: string, operation: ApiOperations) =>
    formatMessage(
      { id: messageId },
      {
        item: formatMessage({ id: `api.operation.item.${item}` }),
        operation: formatMessage({ id: `api.operation.${operation}` }),
      },
    );

  const notifySuccess = (operation: ApiOperations) =>
    notification.success({ message: formatOperationMessage("api.operation.message.success", operation) });

  const notifyFailure = (operation?: ApiOperations) =>
    notification.error({
      message: operation
        ? formatOperationMessage("api.operation.message.error", operation)
        : formatMessage({ id: "errorMessages.response.default" }),
    });

  return { notifySuccess, notifyFailure };
};
